<template>
    <div>
        <m-assembly-table ref='pageForm'
            :formData='formData'
            :columns='columns'
            :data='tableData'
            :tableButtons='tableButtons'
            :loading='loading'
            :currentPage='settings.currentPage'
            :pageSize='settings.pageSize'
            :total='settings.total'
            :settings='settings'
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
            @onSelectionChange="onSelectionChange"
        >
        </m-assembly-table>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import {dateTimeChange, queryIntTimeZone, getOuList} from './financialAccounting';
import moment from 'moment';
export default {
    name: 'intercourseReconciliationsSearch',
    components: { 
        mAssemblyTable 
    },
    data () {
        return {
            lineLoading: false,
            formData: {
                row: 1,
                items: [
                    {
                        value: '',
                        field: 'orgId', // 买方orgId
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: (val) => {
                                // if (val) {
                                //     getVendorSite(this.orgList.find((item) => item.value === val).erpOrgId, this, (data) => {
                                //         data = [
                                //             {
                                //                 label: 'E01009069001B',
                                //                 value: 'E01009069001B'
                                //             }
                                //         ];
                                //         this.getFormDataItemObj(this.formData.items, 'vendorSiteCode').options.values = data;
                                //     });
                                // }
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('intercourse.t1'), // 买方
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require')
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'billStatus', // 状态
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {},
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('groupStop.t11')
                    },
                    {
                        value: '',
                        field: 'endPeriodNameFrom',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {
                            }
                        },
                        type: 'datePicker',
                        options: {
                            type: 'month',
                            format: 'yyyy-MM'
                        },
                        title: this.$t('intercourse.t19'),
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'endPeriodNameTo',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {
                            }
                        },
                        type: 'datePicker',
                        options: {
                            type: 'month',
                            format: 'yyyy-MM'
                        },
                        title: this.$t('截止期间')
                    },
                ]
            },
            billStatusList: [],
            columns: {
                columns: [
                    {
                        title: this.$t('intercourse.t4'), // 明细
                        align: 'center',
                        minWidth: 40,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    size: 'small',
                                    icon: 'm-icon m-icon-ios-list-outline'
                                },
                                on: {
                                    click: () => {
                                        let {billHeaderId, ATTRIBUTE1} = params.row;
                                        this.$router.push({
                                            name: 'intercourseReconciliationsAdd', 
                                            query: {
                                                id: billHeaderId,
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('intercourse.t5'), // 对账单号
                        align: 'center',
                        minWidth: 110,
                        key: 'billNum'
                    },
                    {
                        title: this.$t('intercourse.t6'), // 对账状态
                        align: 'center',
                        minWidth: 90,
                        key: 'billStatus',
                        render: (h, params) => {
                            const data = this.billStatusList.find(item => item.value == params.row.billStatus);
                            return h('span', {}, data.label); 
                        },
                    },
                    {
                        title: this.$t('intercourse.t19'), // 截止期间
                        align: 'center',
                        minWidth: 70,
                        key: 'endPeriodName'
                    },
                    // {
                    //     title: this.$t('fpzInvaccSearch.t7'), // 期间至
                    //     align: 'center',
                    //     minWidth: 70,
                    //     key: 'periodTo'
                    // },
                    {
                        title: this.$t('intercourse.t7'), // 币种
                        align: 'center',
                        minWidth: 90,
                        key: 'currencyCode'
                    },
                    {
                        title: this.$t('intercourse.t8'), // 期末金额
                        align: 'center',
                        minWidth: 90,
                        key: 'endBalanceAmt'
                    },
                    {
                        title: this.$t('intercourse.t9'), // 拒绝原因
                        align: 'center',
                        minWidth: 200,
                        key: 'rejectReason'
                    },
                    {
                        title: this.$t('intercourse.t10'), // 供应商确认日期
                        align: 'center',
                        minWidth: 140,
                        key: 'confirmDate',
                        render: (h, params) => {
                            let {confirmDate} = params.row;
                            return h('span', confirmDate && moment(confirmDate).add(this.offsetTime, 'h').format('YYYY-MM-DD HH:mm:ss') || '');
                        }
                    },
                    {
                        title: this.$t('common.delBtn'), // 删除
                        align: 'center',
                        key: 'status',
                        minWidth: 60,
                        render: (h, params) => {
                            let {billHeaderId, billStatus, endPeriodName, periodTo} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(billStatus);
                            return h('Button', {
                                props: {
                                    type: 'text',
                                    icon: 'trash-b',
                                    disabled
                                },
                                on: {
                                    click: () => {
                                        this.deleteLine(billHeaderId, endPeriodName, periodTo);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('intercourse.t11'), // 对账函
                        align: 'center',
                        key: 'PRINT_FLAG',
                        minWidth: 60,
                        render: (h, params) => {
                            return h('Button',
                                {
                                props: {
                                    type: 'text',
                                    icon: 'printer'
                                },
                                on: {
                                    click: () => {
                                        this.print(params.row.billHeaderId);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t18'), // 附件
                        align: 'center',
                        minWidth: 230,
                        render: (h, params) => {
                            let {billHeaderId, billStatus, accessoryDocId, accessoryName} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(billStatus);
                            let upload = h('Upload', {
                                props: {
                                    action: '/gscint/supplierfile/uploadFile', // 图片、pdf、zip
                                    // format: ['xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'pdf', 'txt', 'xml', 'rar', 'zip', '7z'],
                                    format: ['jpeg', 'jpg', 'png', 'gif', 'pdf', 'zip'],
                                    showUploadList: false,
                                    onSuccess: (response, file) => {
                                        let {fileName, docId} = response.data;
                                        axios.post(`/gscint/bill/billAttachment?accessoryName=${fileName}&accessoryDocId=${docId}&headerId=${billHeaderId}`, {}).then(res => {
                                            if (res.data.success) {
                                                this.$Modal.success({
                                                    content: this.$t('common.upload_success') // 上传成功
                                                });
                                                this.onSubmit();
                                            } else {
                                                this.showErrorTips('loading', res.data.msg);
                                            }
                                        });
                                    },
                                    onFormatError: () => {
                                        let format = ['jpeg', 'jpg', 'png', 'gif', 'pdf', 'zip'];
                                        this.$Modal.error({
                                            // 附件只支持 xxx 格式
                                            content: `${this.$t('fpzInvaccSearch.t20')}${format.join(',')}${this.$t('fpzInvaccSearch.t21')}`
                                        });
                                    }
                                }
                            },
                            [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        icon: 'upload',
                                        disabled
                                    }
                                })
                            ]);
                            if (!accessoryDocId) {
                                return upload;
                            } else {
                                return h('div', {}, [
                                    h('a', {
                                        attrs: {
                                            href: `/gscint/supplierfile/downloadFile?docId=${accessoryDocId}`
                                        }
                                    }, [accessoryName]),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'close',
                                            disabled
                                        },
                                        on: {
                                            click: () => {
                                                params.row.accessoryDocId = '';
                                                params.row.accessoryName = '';
                                                // this.$Modal.confirm({
                                                //     content: this.$t('VendorRegist.vrcolumn95'), // 是否删除附件？
                                                //     onOk: () => {
                                                //         // const url = '/gscint/hw/invacc/uploadFile';
                                                //         // axios.post(url, {
                                                //         //     accessoryName: accessoryName,
                                                //         //     accessoryUrl: accessoryDocId,
                                                //         //     headerId: billHeaderId,
                                                //         //     vendorId: this.vendorId,
                                                //         //     uploadFlag: 'del'
                                                //         // })
                                                //         // .then(res => {
                                                //         //     if (res.data === 'success') {
                                                //         //         this.$Modal.success({
                                                //         //             content: this.$t('common.delete_success') // 删除成功
                                                //         //         });
                                                //         //         this.onSubmit();
                                                //         //     }
                                                //         // });
                                                //     }
                                                // });
                                            }
                                        }
                                    })
                                ]);
                            }
                        }
                    },
                    {
                        title: this.$t('intercourse.t12'), // 确认按钮
                        align: 'center',
                        key: 'status',
                        minWidth: 60,
                        render: (h, params) => {
                            let {billStatus, billHeaderId} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(billStatus);
                            return h('Button',
                                {
                                props: {
                                    type: 'text',
                                    icon: 'checkmark',
                                    loading: this.lineLoading,
                                    disabled
                                },
                                style: {
                                    fontSize: '16px',
                                    color: disabled ? '#bbbec4' : '#2d8cf0'  
                                },
                                on: {
                                    click: () => {
                                        this.lineLoading = true;
                                        this.confirm(billHeaderId, params.row);
                                    }
                                }
                            });
                        }
                    }
                ]
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('intercourse.t13'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            this.$router.push({
                                name: 'intercourseReconciliationsAdd'
                            });
                        }
                    },
                    {
                        label: this.$t('common.export'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                this.$set(button, 'loading', true);
                                this.exportExcel(button);
                            }
                        }
                    }
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false
            },
            selection: [],
            INT_RECONCILIATION_STATUS: [],
            orgList: [],
            offsetTime: 0
        }
    },
    methods: {
        confirm(headerId, {accessoryDocId, accessoryName}) {
            if (!accessoryDocId || !accessoryName) {
                this.$Modal.warning({
                    content: this.$t('fpzInvaccCommon.t37')
                })
                return false;
            }
            axios.post('/gscint/bill/billConfirm', {
                // vendorId: this.vendorId,
                headerId,
                vendorName: localStorage.getItem('supplierInfo') ? JSON.parse(localStorage.getItem('supplierInfo')).vendorName : ''
            })
            .then(res => {
                this.lineLoading = false;
                let {code, msg} = res.data.data;
                if (code == 1) {
                    this.$Modal.success({
                        content: this.$t('groupStop.t16')
                    });
                    this.onSubmit();
                } else {
                    this.$Modal.error({
                        content: msg
                    });
                }
            })
            .catch(() => {
                this.lineLoading = false;
                this.showErrorTips();
            })
        },
        deleteLine (headerId, from, to) {
            this.$Modal.confirm({
                // 确定要删除对账期间 from 到 to 的对账单吗？
                content: `<p>${this.$t('fpzInvaccSearch.t12')}${from}${this.$t('fpzInvaccSearch.t14')}</p>`,
                onOk: () => {
                    axios({
                        url: '/gscint/bill/billDelete?headerId='+headerId,
                        method: 'get'
                    }).then(res => {
                        console.log('resp', res);
                        if (res.data.success) {
                            this.onSubmit();
                            setTimeout(() => {
                                this.$Modal.success({
                                    content: this.$t('common.delete_success')
                                });
                            }, 500);
                        } else {
                            setTimeout(() => {
                                this.showErrorTips('loading', res.data.msg);
                            }, 500);
                        }
                    })
                    .catch(() => {
                        this.showErrorTips();
                    });
                }
            });
        },
        print(headerId) {
            axios.get('/gscint/bill/billPrint?headerId='+headerId)
            .then((res) => {
                console.log('res---1', res)
                let datas = res.data.data.datas;
                datas.billLines = datas.list;
                // debugger;
                this.cloudPrint('ispBillDetailNew-hw', { reportlets: datas });
            });
        },
        str2camel(str) {
            str = str.toLowerCase();
            let newStr = '';
            for (let i = 0; i < str.length; i++) {
            if (str[i] === '_') {
                i++;
                if (str[i]) {
                newStr += str[i].toUpperCase();
                }
                continue;
            }
            newStr += str[i];
            }
            return newStr;
        },
        onSubmit () {
            this.loading = true;
            axios.post('/gscint/bill/queryHeaderPage', {
                ...this.getFormDataVModel(this.formData.items),
                vendorId: this.vendorId,
                pageIndex: this.settings.currentPage,
                pageSize:  this.settings.pageSize,
                vendorCode: this.vendorCode,
            })
            .then(res => {
                this.loading = false;
                let {list, total} = res.data.data.datas;
                // debugger
                this.tableData = list;
                this.settings.total = total;
                queryIntTimeZone(this.getFormDataVModel(this.formData.items).orgId, (data) => {
                    this.offsetTime = data;
                });
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSubmit();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSubmit();
        },
        onSelectionChange (selection) {
            this.selection = selection;
        },
        exportExcel (button) {
            this.$set(button, 'loading', true);
            let paraJson = {
                ...this.getFormDataVModel(this.formData.items),
                vendorId: this.vendorId,
                vendorCode: this.vendorCode,
                language: this.$i18n.locale == 'zh-CN' ? 'zh-CN' : 'en-US',
            }
            axios({
                url: '/gscint/bill/exportHeader',
                method: 'post',
                responseType: 'blob',
                data: paraJson
            }).then((res) => {
                this.$set(button, 'loading', false);
                this.downloadFile(res.data, '往来对账查询.xlsx');
            })
            .catch(() => {
                this.showErrorTips();
            });
            
        }
    },
    mounted() {
        getOuList((data) => {
            console.log('data', data)
            this.orgList = data;
            this.getFormDataItemObj(this.formData.items, 'orgId').options.values = data;
        });
        this.getDict('INT_RECONCILIATION_STATUS', (data) => {
            let arr = [];
            data.forEach(item => {
                if(this.$i18n.locale != 'zh-CN' && item.email != 'N') {
                    item.label == item.valueEn || item.label;
                    arr.push(item);
                } else if(item.email != 'N') {
                    arr.push(item);
                }
            })
            this.billStatusList = arr;
            this.getFormDataItemObj(this.formData.items, 'billStatus').options.values = arr;
        });
    },
}
</script>
<style scoped lang="less">
/deep/ .m-date-picker{
    width: 100%;
}
</style>